import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import FilterTag from './filter-tag-model';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-filter-tag-container',
  standalone: true,
  imports: [CommonModule, MatChipsModule, MatIconModule,],
  templateUrl: './filter-tag-container.component.html',
  styleUrls: ['./filter-tag-container.component.css']
})
export class FilterTagContainerComponent {
  @Output() onClearAll = new EventEmitter<void>();
  @Output() onRemoveTag = new EventEmitter<{ type: string, value: string }>();


  constructor(private cdRef: ChangeDetectorRef) {

  }

  protected filters: FilterTag[] = []

  addFilterTag(filterTag: FilterTag) {
    console.log("APPLYING", filterTag)
    filterTag.label = filterTag.label.replaceAll("_", " ").toLowerCase();
    this.removeTag(filterTag);
    this.filters.push(filterTag);
    this.cdRef.detectChanges()
  }



  clearAll(): void {
    this.filters = []
    this.onClearAll.emit();
  }

  removeTag(filterTag: FilterTag) {
    this.filters = this.filters.filter(filter => filter.label != filterTag.label && filter.type != filterTag.type);
  }

  onRemoveTagClick(type: string, value: string): void {
    this.onRemoveTag.emit({ type, value });
  }



}